<template>
  <div
    v-if="filterStore.available.prices?.length > 1"
    :class="[$style['filter'], $style['filter--price']]">
    <div :class="$style['filter__title']">
      {{ $t('general/filter-price') }}

      <Btn v-if="filterStore.active.prices.length" icon-right="System/close-line" color="link" size="small" @click="filterStore.resetFilter('prices')">
        Reset filter
      </Btn>
    </div>
    <div :class="$style['filter__container']">
      <Btn
        v-for="(row, index) in nonActivePrices"
        :key="index"
        border
        font-size="small"
        no-padding="all"
        :postfix="row.count ? row.count : '0'"
        :class="$style['filter__content']"
        :color="isActive(row.value) ? 'cta' : 'white'"
        :disabled="!row.count"
        @click="check(row.value)">
        {{ row.title }}
      </Btn>
    </div>
  </div>
</template>
<script setup>
const filterStore = useFilterStore()
const isActive = item => {
  return filterStore.active.prices.includes(item)
}

const check = price => {
  filterStore.toggle({
    filter: 'prices',
    value: price
  })
}

const nonActivePrices = computed(() => {
  return filterStore.available.prices
})

</script>
<style lang="scss" module>
@use './style' as *;

.filter {
  &__container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: var(--spacing);
  }
}
</style>
